<section class="hero is-link is-small">
  <div class="hero-body"><div class="container"><h1 class="title"><span class="icon-text"><span class="icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span><span>Small Cat</span></span></h1></div></div>
</section>
<section class="section container" id="smolcat-content" aria-live="polite">
  <p class="loading"><span class="icon"><i class="fa-solid fa-ellipsis fa-fade" aria-hidden="true"></i></span> Finding a small cat…</p>
</section>
